import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { addMessage, clearMessage } from '../actions/flash';

export type FlashType = 'info' | 'error' | 'success' | 'warning';

export interface FlashOptions {
  type?: FlashType;
  autoDisappear?: boolean;
  sticky?: boolean;
}

/**
 * Hook to display flash messages.
 * This is a thin wrapper around the Redux flash actions for use in
 * components that have migrated away from Redux connect().
 */
export function useFlashMessage() {
  const dispatch = useDispatch();

  const addFlash = useCallback(
    (message: string, options: FlashOptions = {}) => {
      dispatch(addMessage(message, options));
    },
    [dispatch],
  );

  const clearFlash = useCallback(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  return { addFlash, clearFlash };
}
